import React, { useEffect, useContext, useState } from "react";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { RootContext } from "../../contexts/root-context";
import axios from "axios";
import { BEDAS_BASE_URL } from "../../strings";
import { getToken } from "./get-token";
import { decryptData } from "../../util";
import "./user-session.css";
const UserSession = () => {

    const navigate = useNavigate();
    const location = useLocation()
    const { authDetails, setauthDetails } = useContext(RootContext);
    const [showSessionExpired, setShowSessionExpired] = useState(false);


    const reloadPage = async () => {

        let username = decryptData(localStorage.getItem("logged_in_user"));

        try {
            const response = await axios.get(
                BEDAS_BASE_URL + `rbac-get?id=` + username.trim(), getToken()
            );
            let userInfo = response.data;

            setauthDetails([{ ...authDetails, userInfo: userInfo }]);
            localStorage.setItem("USER_INFO", JSON.stringify(userInfo));

        } catch (error) {

        }
        //  }
        window.location.reload();
    }
    useEffect(() => {
        checkUserSession();
        
        // Listen for session expired events from get-token.js
        const handleSessionExpired = (event) => {
            console.log('Session expired event received:', event.detail);
            setShowSessionExpired(true);
        };
        
        window.addEventListener('sessionExpired', handleSessionExpired);
        
        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('sessionExpired', handleSessionExpired);
        };
    }, [location.pathname]);   
    
    const checkUserSession = async () => {
        try {
            const currentSession = await Auth.currentSession();
            
            if (location.pathname === "/") {
                reloadPage();
                navigate("./substation-explorer");
                return;
            }

            const accessToken = currentSession.getAccessToken();
            const expirationTime = new Date(accessToken.payload.exp * 1000);
            const currentTime = new Date();

            if (expirationTime < currentTime) {
                try {
                    await Auth.refreshSession(currentSession.refreshToken);
                    console.log("Session refreshed successfully");
                } catch (refreshError) {
                    console.error("Session refresh failed:", refreshError);
                    setShowSessionExpired(true);
                }
            }
        } catch (error) {
            console.error("Session check failed:", error);
            if (error === "No current user" || error.message === "No current user") {
                setShowSessionExpired(true);
            }
        } finally {
            console.log("Session check completed");
        }
    };    
    
    
    const handleLoginClick = (event) => {

        console.log("Login button clicked");
        event.preventDefault();
        localStorage.clear();
        event.stopPropagation();
        
        setShowSessionExpired(false);
        
        // Clear any existing session data
        Auth.signOut().catch(console.error);
        
        // Small delay to ensure state is updated
        setTimeout(() => {
            navigate("/");
        }, 100);
    };


   return (
        <>
            {showSessionExpired && (
                <div className="session-expired-overlay">
                    <div className="session-expired-modal">
                        <div className="session-expired-content">
                            <h2 className="session-expired-title">Your session has expired.</h2>
                            <p className="session-expired-message">
                                Your login session has expired. Please login again.
                            </p>
                            <button 
                                className="session-expired-login-btn"
                                onClick={handleLoginClick}
                                type="button"
                                style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                            >
                                Log in
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserSession;
